// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Scrollbars from 'react-custom-scrollbars';

import '../../styles/modal.css';

export default class Modal extends React.Component {

    renderContent = () => (<></>);

    alert = async () => {
        await this.setState({ alert: false });
        return setTimeout(() => this.setState({ alert: true }), 50);
    }

    componentDidMount = () => {
        // Listen for escape key and close the modal 
        document.addEventListener('keydown', this.handleKeyDown); 
    }

    componentWillUnmount = () => {
        // Remove the event listener when the component unmounts
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && !this.props.noClose) {
            this.props.modal();
        }
    } 

    render = () => {
        return (<div
            className="modal-container"
            // onClick={() => this.props.modal()}
        >

            {!this.props.noClose && <img
                className="document-close"
                src="https://static.stax.ai/images/icons/close.png"
                alt="x"
                title="Close [Esc]"
                onClick={() => this.props.modal()}
            />}

            <Scrollbars>
                {this.renderContent()}
            </Scrollbars>
            
        </div>);
    }

};